module.exports = __webpack_public_path__ + "images/agro01-b2863a39fda3e5ee500addc334b2e80a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/agro01.jpeg
// module id = 222
// module chunks = 0